module.exports = __webpack_public_path__ + "img/y2.c99b8704.png";